// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3_sW0","footer":"ModalCreateQualiphyProcedure_footer__1vhJb","additionData":"ModalCreateQualiphyProcedure_additionData__2tbUV"};